
// Data for Energy Analytics charts and visualizations

export const consumptionData = [
  { name: 'Jan', consumption: 400 },
  { name: 'Feb', consumption: 380 },
  { name: 'Mar', consumption: 350 },
  { name: 'Apr', consumption: 320 },
  { name: 'May', consumption: 300 },
  { name: 'Jun', consumption: 350 },
  { name: 'Jul', consumption: 450 },
  { name: 'Aug', consumption: 470 },
  { name: 'Sep', consumption: 420 },
  { name: 'Oct', consumption: 380 },
  { name: 'Nov', consumption: 410 },
  { name: 'Dec', consumption: 430 },
];

export const voltageData = [
  { time: '00:00', voltage: 220 },
  { time: '02:00', voltage: 222 },
  { time: '04:00', voltage: 225 },
  { time: '06:00', voltage: 230 },
  { time: '08:00', voltage: 235 },
  { time: '10:00', voltage: 233 },
  { time: '12:00', voltage: 228 },
  { time: '14:00', voltage: 226 },
  { time: '16:00', voltage: 223 },
  { time: '18:00', voltage: 221 },
  { time: '20:00', voltage: 219 },
  { time: '22:00', voltage: 220 },
];

export const amperageData = [
  { time: '00:00', amperage: 10 },
  { time: '02:00', amperage: 8 },
  { time: '04:00', amperage: 7 },
  { time: '06:00', amperage: 12 },
  { time: '08:00', amperage: 18 },
  { time: '10:00', amperage: 21 },
  { time: '12:00', amperage: 23 },
  { time: '14:00', amperage: 19 },
  { time: '16:00', amperage: 17 },
  { time: '18:00', amperage: 20 },
  { time: '20:00', amperage: 15 },
  { time: '22:00', amperage: 13 },
];

export const energyDistribution = [
  { name: 'HVAC', value: 35 },
  { name: 'Lighting', value: 20 },
  { name: 'Office Equipment', value: 15 },
  { name: 'Data Center', value: 25 },
  { name: 'Other', value: 5 },
];

export const COLORS = ['#0A84FF', '#FF453A', '#30D158', '#FF9F0A', '#5E5CE6'];

export const recentAlarms = [
  { id: 1, device: 'Main Panel A', issue: 'High Voltage', severity: 'High', time: '2 hours ago' },
  { id: 2, device: 'Floor 3 Substation', issue: 'Circuit Overload', severity: 'Medium', time: '5 hours ago' },
  { id: 3, device: 'East Wing Lighting', issue: 'Power Fluctuation', severity: 'Low', time: '1 day ago' },
  { id: 4, device: 'HVAC Controller', issue: 'Connection Loss', severity: 'Medium', time: '2 days ago' },
];

export const getSeverityColor = (severity: string) => {
  switch (severity) {
    case 'High': return 'text-energy-red';
    case 'Medium': return 'text-amber-500';
    case 'Low': return 'text-energy-green';
    default: return 'text-gray-500';
  }
};
